// Prepends "0" to a number (string or integer) if it has fewer than 2 digits (e.g. "7" to "07")
export default function(value) {
	// Nope, not dealing with this if it's nothing
	if (value === null || value === undefined) return '';

	// If this is a numeric string with only one digit, prepend a "0"
	if (value.toString().length <= 1) {
		return '0' + value.toString();
	}
	return value.toString();
}
